import styled from "styled-components";
import { Box, TextField, Typography } from "@mui/material";
import { LoadingButton } from "@mui/lab";

export const Container = styled(Box)`
  && {
    position: absolute;
    left: 50%;
    width: 50%;
    height: 100%;
  }
`;

export const Instruction = styled(Typography)`
  && {
    font-family: "Montserrat";
    font-style: normal;
    font-weight: 500;
    font-size: 24px;
    line-height: 29px;
    color: #000000;
    margin-top: 44px;
  }
`;

export const Title = styled(Typography)`
  && {
    font-family: "Noto Serif";
    font-style: normal;
    font-weight: 600;
    font-size: 48px;
    line-height: 65px;
    color: #000000;
  }
`;

export const InputTextField = styled(TextField)`
  && {
    .MuiOutlinedInput-root {
      width: 480px;
      height: 40px;
      background: #eaeef2;
      border-radius: 10px;
      & > fieldset {
        border: none;
      }
    }
  }
`;

export const InputLabel = styled(Typography)`
  && {
    font-family: "Montserrat";
    font-style: normal;
    font-weight: 500;
    font-size: 20px;
    line-height: 24px;
    color: #000000;
  }
`;

export const SendOtpButton = styled(LoadingButton)`
  && {
    width: 175px;
    height: 50px;
    background: #f2753b;
    border-radius: 5px;
    text-transform: capitalize;
    font-family: Montserrat;
    font-style: normal;
    font-weight: 600;
    font-size: 20px;
    line-height: 24px;
    text-align: center;
    letter-spacing: 0.05em;
    color: #ffffff;
    margin: 20px auto;
    &:hover {
      background: #f2753b;
    }
  }
`;
